import type { JSX } from 'react'

import {
  Button,
  IconButton,
  PlusIcon,
  pageHeaderStyles,
} from '@buffer-mono/popcorn'

type NewPostHeaderActionsProps = {
  wrapTrigger: (trigger: JSX.Element) => JSX.Element
}

export function NewPostHeaderActions({
  wrapTrigger,
}: NewPostHeaderActionsProps): JSX.Element {
  return (
    <>
      <div className={pageHeaderStyles.hideOnNarrow}>
        {wrapTrigger(
          <Button size="medium" variant="secondary">
            <PlusIcon /> New Post
          </Button>,
        )}
      </div>
      {wrapTrigger(
        <IconButton
          variant="primary"
          label="New Post"
          size="large"
          className={pageHeaderStyles.hideOnWide}
        >
          <PlusIcon />
        </IconButton>,
      )}
    </>
  )
}
